module.exports = __webpack_public_path__ + "media/assets/images/common/twitter-54c86a866a97eca96c0598d2a94a7c55.png";